export default "__VITE_ASSET__Dlx3dwfL__";